import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 4L8 8M12 12L8 8M8 8L12 4M8 8L4 12", stroke: "#333D47" }));
export default SvgClose;
